'use strict';

var Range = require('../internal/Range');

var PrimitiveRangeConstructor = function(start, end) {
  return new Range(start, end);
};

module.exports = PrimitiveRangeConstructor;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/range/var/PrimitiveRangeConstructor.js
// module id = 319
// module chunks = 0